import React, { createContext, useContext, useState } from 'react';
import { Popup, PopupTypes } from '../components/Popup';

const PopupContext = createContext();

export function PopupProvider({ children }) {
  const [popup, setPopup] = useState({ message: '', type: '', visible: false });
  const [confirmation, setConfirmation] = useState({ 
    title: '', 
    message: '', 
    visible: false, 
    onConfirm: null, 
    onCancel: null,
    data: null,
    confirmLabel: 'Confirm',
    cancelLabel: 'Cancel',
    confirmVariant: 'primary',
    iconName: '',
  });

  const showPopup = (message, type = 'info') => {
    setPopup({ message, type, visible: true });
    setTimeout(() => {
      setPopup(prev => ({ ...prev, visible: false }));
    }, 3000);
  };

  const showConfirmation = (title, message, onConfirm, onCancel = null, options = {}) => {
    const opts = options || {};
    setConfirmation({
      title,
      message,
      visible: true,
      onConfirm,
      onCancel,
      data: opts.data ?? null,
      confirmLabel: opts.confirmLabel || 'Confirm',
      cancelLabel: opts.cancelLabel || 'Cancel',
      confirmVariant: opts.confirmVariant || 'primary',
      iconName: opts.iconName || '',
    });
  };

  const hideConfirmation = () => {
    setConfirmation(prev => ({ ...prev, visible: false }));
  };

  const handleConfirm = () => {
    if (confirmation.onConfirm) {
      confirmation.onConfirm(confirmation.data);
    }
    hideConfirmation();
  };

  const handleCancel = () => {
    if (confirmation.onCancel) {
      confirmation.onCancel();
    }
    hideConfirmation();
  };

  return (
    <PopupContext.Provider value={{ 
      popup, 
      showPopup, 
      confirmation, 
      showConfirmation, 
      hideConfirmation,
      handleConfirm,
      handleCancel
    }}>
      {children}
      <Popup />
    </PopupContext.Provider>
  );
}

export const usePopup = () => useContext(PopupContext); 